// For now, this is a list of voices that we have permission to use.
// This is a temporary solution until we have a proper subscription system.

export const subscribedVoices = {}; // This have moved to synthetic_voices table.
